import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {CUSTOMER_PORTAL_CONFIG, LANGUAGE} from 'src/constants/local-storage-variables';
import {environment} from '../environments/environment';
import {EnvironmentResolveService} from './core/services/environment-resolve/environment-resolve.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Asseco-SEE';

  constructor(
    translate: TranslateService,
    private erService: EnvironmentResolveService
  ) {
    const defaultLang = this.erService.environmentERS.hasOwnProperty('defaultLang') ? this.erService.environmentERS.defaultLang.split('_')[0] : 'en';
    const lang = localStorage.getItem(LANGUAGE) || defaultLang;
    translate.setDefaultLang(defaultLang);
    translate.use(lang);
  }

  ngOnInit(): void {
  }
}
